import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MenuService {
    private _openMenuEvent$ = new EventEmitter<void>();
    private _closeMenuEvent$ = new EventEmitter<void>();

    get openMenuEvent$(): Observable<void> {
        return this._openMenuEvent$;
    }

    get closeMenuEvent$(): Observable<void> {
        return this._closeMenuEvent$;
    }

    openMenu(): void {
        this._openMenuEvent$.next();
    }

    closeMenu(): void {
        this._closeMenuEvent$.next();
    }
}
